import { PROMOTE_APP_TRACK_NAME } from '../../../common/promote-app/promote-app.constants';
import { FEATURE_SWITCH_NAMES } from '../../../constants/feature-switch-names';
import { storageKeys } from '../../../utils/browser-storage/storage-keys';
import qualityEventsHelpers from '../quality-events.helpers';

export const GENERAL_QUALITY_EVENTS = {
    smartBannerDownload() {
        qualityEventsHelpers.track({
            type: 'DownloadAppButtonClicked'
        });
    },
    trackPageView() {
        qualityEventsHelpers.track({
            type: 'pageView'
        });
    },
    foldersAnnouncementPopup(extra: string) {
        qualityEventsHelpers.track({
            extra,
            type: 'foldersAnnouncementPopup'
        });
    },
    liveSessionBar() {
        qualityEventsHelpers.track({
            extra: JSON.stringify(Date.now()),
            type: FEATURE_SWITCH_NAMES.LIVE_SESSION_BAR,
            user_id: window.storage.getItem(storageKeys.user.userId)
        });
    },
    marketingBar(currentBannerId: string, extra: string) {
        qualityEventsHelpers.track({
            extra,
            source: currentBannerId,
            type: 'marketingBarEvent'
        });
    },
    newWorldsPromotion(extra: string) {
        qualityEventsHelpers.track({ extra, type: 'newWorldsPromotionPopupInteraction' });
    },
    personalizationModal() {
        qualityEventsHelpers.track({ type: 'showP13nModal' });
    },
    interactiveQuizPopup() {
        qualityEventsHelpers.track({
            extra: JSON.stringify({
                user_id: window.storage.getItem(storageKeys.user.userId)
            }),
            type: 'interactive-quiz-announcement-popup'
        });
    },
    promoteAppBanner(type: string, extraTrackParams: { promoteAppTrackName: string; promotionName: string }) {
        qualityEventsHelpers.track({
            type: `${PROMOTE_APP_TRACK_NAME}-${type}`,
            extra: JSON.stringify(extraTrackParams)
        });
    },
    toggleWorldSwitch(extra: string) {
        qualityEventsHelpers.track({
            extra,
            type: 'toggleWorldSwitch'
        });
    },
    newFeatureTour(source: string) {
        qualityEventsHelpers.track({
            type: 'completedNewFeatureTour',
            source
        });
    },
    pinterestFooterClick() {
        qualityEventsHelpers.track({
            type: 'PinterestSocialLinkClick'
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    freeDownload(materialInfo: Material, extra?: any) {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData(materialInfo),
            type: 'freeDownload',
            extra: JSON.stringify(extra)
        });
    },
    downloadPurchasedMaterial(materialId?: number): Promise<void> {
        return qualityEventsHelpers.track({
            type: 'download-purchased-material-click',
            extra: JSON.stringify({
                materialId,
                source: JSON.stringify(window.location.href)
            })
        });
    },
    requestSalesReport(type: 'xlsx' | 'csv') {
        qualityEventsHelpers.track({
            type: 'requestSalesReport',
            extra: JSON.stringify({ format: type })
        });
    },
    freeDownloadCatalog(material_id: number) {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData({ id: material_id } as Material),
            source: 'catalog',
            type: 'freeDownload'
        });
    }
};
